/**
 * A global configuration object
 */
const PassengerItem = [
  { id: 2, code: '2', name: '2' },
  { id: 3, code: '3', name: '3' },
  { id: 4, code: '4', name: '4' },
  { id: 5, code: '5', name: '5' },
  { id: 6, code: '6', name: '6' },
  { id: 7, code: '7', name: '7' },
  { id: 8, code: '8', name: '8' },
  { id: 9, code: '9', name: '9' },
  { id: 10, code: '10', name: '10' },
  { id: 11, code: '11', name: '11' },
  { id: 12, code: '12', name: '12' },
  { id: 13, code: '13', name: '13' },
  { id: 14, code: '14', name: '14' },
  { id: 15, code: '15', name: '15' },
];

export default PassengerItem;
